"use client"

import React, { useState, useEffect } from "react"
import api from "../config/api"
import { FiPlus, FiEdit2, FiTrash2 } from "react-icons/fi"
import "./Communications.css"

const Communications = () => {
    const [communications, setCommunications] = useState([])
    const [customers, setCustomers] = useState([])
    const [loading, setLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [selectedComm, setSelectedComm] = useState(null)
    const [formData, setFormData] = useState({
        customer_id: "",
        type: "phone",
        result: "",
        notes: "",
        contacted_at: new Date().toISOString().slice(0, 16),
    })
    const [error, setError] = useState("")

    useEffect(() => {
        loadData()
    }, [])

    const loadData = async () => {
        try {
            const [commsRes, customersRes] = await Promise.all([api.get("/communications"), api.get("/customers")])
            setCommunications(commsRes.data.data || commsRes.data)
            setCustomers(customersRes.data.data || customersRes.data)
        } catch (error) {
            console.error("Veri yüklenemedi:", error)
        } finally {
            setLoading(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError("")

        try {
            if (selectedComm) {
                await api.put(`/communications/${selectedComm.id}`, formData)
            } else {
                await api.post("/communications", formData)
            }
            setShowModal(false)
            resetForm()
            loadData()
        } catch (error) {
            setError(error.response?.data?.message || "İşlem başarısız")
        }
    }

    const handleDelete = async (id) => {
        if (!window.confirm("Bu kaydı silmek istediğinizden emin misiniz?")) return

        try {
            await api.delete(`/communications/${id}`)
            loadData()
        } catch (error) {
            alert("Silme işlemi başarısız")
        }
    }

    const handleEdit = (comm) => {
        setSelectedComm(comm)
        setFormData({
            customer_id: comm.customer_id,
            type: comm.type,
            result: comm.result || "",
            notes: comm.notes || "",
            contacted_at: comm.contacted_at.slice(0, 16),
        })
        setShowModal(true)
    }

    const resetForm = () => {
        setFormData({
            customer_id: "",
            type: "phone",
            result: "",
            notes: "",
            contacted_at: new Date().toISOString().slice(0, 16),
        })
        setSelectedComm(null)
        setError("")
    }

    if (loading) {
        return React.createElement("div", { className: "loading" }, React.createElement("div", { className: "spinner" }))
    }

    return React.createElement(
        "div",
        { className: "communications-page" },
        React.createElement(
            "div",
            { className: "page-header" },
            React.createElement("h1", null, "İletişim Takibi"),
            React.createElement(
                "button",
                {
                    className: "btn btn-primary",
                    onClick: () => {
                        resetForm()
                        setShowModal(true)
                    },
                },
                React.createElement(FiPlus),
                "Yeni İletişim",
            ),
        ),
        React.createElement(
            "div",
            { className: "desktop-table" },
            React.createElement(
                "div",
                { className: "card" },
                React.createElement(
                    "div",
                    { className: "table-container" },
                    React.createElement(
                        "table",
                        null,
                        React.createElement(
                            "thead",
                            null,
                            React.createElement(
                                "tr",
                                null,
                                React.createElement("th", null, "Müşteri"),
                                React.createElement("th", null, "Şirket"), // Added Şirket column
                                React.createElement("th", null, "Tür"),
                                React.createElement("th", null, "Sonuç"),
                                React.createElement("th", null, "Tarih"),
                                React.createElement("th", null, "Personel"),
                                React.createElement("th", null, "İşlemler"),
                            ),
                        ),
                        React.createElement(
                            "tbody",
                            null,
                            communications.map((comm) =>
                                React.createElement(
                                    "tr",
                                    { key: comm.id },
                                    React.createElement(
                                        "td",
                                        null,
                                        comm.customer ? `${comm.customer.first_name} ${comm.customer.last_name}` : "-",
                                    ),
                                    React.createElement("td", null, comm.customer?.company_name || "-"),
                                    React.createElement(
                                        "td",
                                        null,
                                        React.createElement(
                                            "span",
                                            { className: "badge badge-info" },
                                            comm.type === "phone" ? "Telefon" : comm.type === "whatsapp" ? "WhatsApp" : "E-posta",
                                        ),
                                    ),
                                    React.createElement(
                                        "td",
                                        null,
                                        comm.result &&
                                        React.createElement(
                                            "span",
                                            {
                                                className: `badge ${
                                                    comm.result === "positive"
                                                        ? "badge-success"
                                                        : comm.result === "negative"
                                                            ? "badge-danger"
                                                            : "badge-warning"
                                                }`,
                                            },
                                            comm.result === "positive" ? "Olumlu" : comm.result === "negative" ? "Olumsuz" : "Nötr",
                                        ),
                                    ),
                                    React.createElement("td", null, new Date(comm.contacted_at).toLocaleString("tr-TR")),
                                    React.createElement("td", null, comm.user ? `${comm.user.first_name} ${comm.user.last_name}` : "-"),
                                    React.createElement(
                                        "td",
                                        null,
                                        React.createElement(
                                            "div",
                                            { className: "action-buttons" },
                                            React.createElement(
                                                "button",
                                                { className: "btn-icon", onClick: () => handleEdit(comm) },
                                                React.createElement(FiEdit2),
                                            ),
                                            React.createElement(
                                                "button",
                                                { className: "btn-icon danger", onClick: () => handleDelete(comm.id) },
                                                React.createElement(FiTrash2),
                                            ),
                                        ),
                                    ),
                                ),
                            ),
                        ),
                    ),
                ),
            ),
        ),
        React.createElement(
            "div",
            { className: "mobile-cards" },
            communications.map((comm) =>
                React.createElement(
                    "div",
                    { key: comm.id, className: "mobile-card" },
                    React.createElement(
                        "div",
                        { className: "mobile-card-header" },
                        React.createElement(
                            "div",
                            null,
                            React.createElement(
                                "h3",
                                null,
                                comm.customer ? `${comm.customer.first_name} ${comm.customer.last_name}` : "-",
                            ),
                            comm.customer?.company_name &&
                            React.createElement("p", { className: "mobile-card-company" }, comm.customer.company_name),
                        ),
                        React.createElement(
                            "span",
                            { className: "badge badge-info" },
                            comm.type === "phone" ? "Telefon" : comm.type === "whatsapp" ? "WhatsApp" : "E-posta",
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "mobile-card-body" },
                        comm.result &&
                        React.createElement(
                            "div",
                            { className: "mobile-card-row" },
                            React.createElement("span", { className: "mobile-card-label" }, "Sonuç:"),
                            React.createElement(
                                "span",
                                {
                                    className: `badge ${
                                        comm.result === "positive"
                                            ? "badge-success"
                                            : comm.result === "negative"
                                                ? "badge-danger"
                                                : "badge-warning"
                                    }`,
                                },
                                comm.result === "positive" ? "Olumlu" : comm.result === "negative" ? "Olumsuz" : "Nötr",
                            ),
                        ),
                        React.createElement(
                            "div",
                            { className: "mobile-card-row" },
                            React.createElement("span", { className: "mobile-card-label" }, "Tarih:"),
                            React.createElement("span", null, new Date(comm.contacted_at).toLocaleString("tr-TR")),
                        ),
                        comm.user &&
                        React.createElement(
                            "div",
                            { className: "mobile-card-row" },
                            React.createElement("span", { className: "mobile-card-label" }, "Personel:"),
                            React.createElement("span", null, `${comm.user.first_name} ${comm.user.last_name}`),
                        ),
                        comm.notes &&
                        React.createElement(
                            "div",
                            { className: "mobile-card-notes" },
                            React.createElement("span", { className: "mobile-card-label" }, "Notlar:"),
                            React.createElement("p", null, comm.notes),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "mobile-card-actions" },
                        React.createElement(
                            "button",
                            { className: "btn-icon", onClick: () => handleEdit(comm) },
                            React.createElement(FiEdit2),
                        ),
                        React.createElement(
                            "button",
                            { className: "btn-icon danger", onClick: () => handleDelete(comm.id) },
                            React.createElement(FiTrash2),
                        ),
                    ),
                ),
            ),
        ),
        showModal &&
        React.createElement(
            "div",
            { className: "modal-overlay", onClick: () => setShowModal(false) },
            React.createElement(
                "div",
                { className: "modal", onClick: (e) => e.stopPropagation() },
                React.createElement("h2", null, selectedComm ? "İletişim Düzenle" : "Yeni İletişim"),
                error && React.createElement("div", { className: "error-message" }, error),
                React.createElement(
                    "form",
                    { onSubmit: handleSubmit },
                    React.createElement(
                        "div",
                        { className: "input-group" },
                        React.createElement("label", null, "Müşteri *"),
                        React.createElement(
                            "select",
                            {
                                value: formData.customer_id,
                                onChange: (e) => setFormData({ ...formData, customer_id: e.target.value }),
                                required: true,
                            },
                            React.createElement("option", { value: "" }, "Seçiniz"),
                            customers.map((customer) =>
                                React.createElement(
                                    "option",
                                    { key: customer.id, value: customer.id },
                                    `${customer.first_name} ${customer.last_name}${customer.company_name ? ` - ${customer.company_name}` : ""}`,
                                ),
                            ),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "İletişim Türü *"),
                            React.createElement(
                                "select",
                                {
                                    value: formData.type,
                                    onChange: (e) => setFormData({ ...formData, type: e.target.value }),
                                    required: true,
                                },
                                React.createElement("option", { value: "phone" }, "Telefon"),
                                React.createElement("option", { value: "whatsapp" }, "WhatsApp"),
                                React.createElement("option", { value: "email" }, "E-posta"),
                            ),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Sonuç"),
                            React.createElement(
                                "select",
                                {
                                    value: formData.result,
                                    onChange: (e) => setFormData({ ...formData, result: e.target.value }),
                                },
                                React.createElement("option", { value: "" }, "Seçiniz"),
                                React.createElement("option", { value: "positive" }, "Olumlu"),
                                React.createElement("option", { value: "negative" }, "Olumsuz"),
                                React.createElement("option", { value: "neutral" }, "Nötr"),
                            ),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "input-group" },
                        React.createElement("label", null, "İletişim Tarihi *"),
                        React.createElement("input", {
                            type: "datetime-local",
                            value: formData.contacted_at,
                            onChange: (e) => setFormData({ ...formData, contacted_at: e.target.value }),
                            required: true,
                        }),
                    ),
                    React.createElement(
                        "div",
                        { className: "input-group" },
                        React.createElement("label", null, "Notlar"),
                        React.createElement("textarea", {
                            value: formData.notes,
                            onChange: (e) => setFormData({ ...formData, notes: e.target.value }),
                        }),
                    ),
                    React.createElement(
                        "div",
                        { className: "modal-actions" },
                        React.createElement(
                            "button",
                            { type: "button", className: "btn btn-secondary", onClick: () => setShowModal(false) },
                            "İptal",
                        ),
                        React.createElement("button", { type: "submit", className: "btn btn-primary" }, "Kaydet"),
                    ),
                ),
            ),
        ),
    )
}

export default Communications
